import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'

const GET_MATERIAL_REQUEST = 'Material/GET_MATERIAL_REQUEST'
const GET_MATERIAL_SUCCESS = 'Material/GET_MATERIAL_SUCCESS'
const GET_MATERIAL_FAILURE = 'Material/GET_MATERIAL_FAILURE'

const GET_MATERIAL_BY_CATEGORY_ID_REQUEST =
  'Material/GET_MATERIAL_BY_CATEGORY_ID_REQUEST'
const GET_MATERIAL_BY_CATEGORY_ID_SUCCESS =
  'Material/GET_MATERIAL_BY_CATEGORY_ID_SUCCESS'
const GET_MATERIAL_BY_CATEGORY_ID_FAILURE =
  'Material/GET_MATERIAL_BY_CATEGORY_ID_FAILURE'

const SAVE_MATERIAL_LIST = 'Material/SAVE_MATERIAL_LIST'
const SAVE_SELECTED_LIST = 'Material/SAVE_SELECTED_LIST'
const REMOVE_SELECTED_LIST = 'Material/REMOVE_SELECTED_LIST'

// Initialize State
const initialState = {
  user: {},
  isLoading: true,
  error: {},
  token: '',
  materials: [],
  materialList: [],
  selectedList: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MATERIAL_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_MATERIAL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        materials: action.payload
      }
    case GET_MATERIAL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_MATERIAL_BY_CATEGORY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_MATERIAL_BY_CATEGORY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        materialList: action.payload
      }
    case GET_MATERIAL_BY_CATEGORY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_SELECTED_LIST:
      return {
        ...state,
        error: action.error,
        selectedList: action.payload
      }
    case REMOVE_SELECTED_LIST:
      return {
        ...state,
        error: action.error,
        selectedList: action.payload
      }
    default:
      return state
  }
}

// Action Creators
export const getMaterials = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_MATERIAL_REQUEST
      })

      const response = await API.get(EndPoints.PRODUCT + `/groupByCategory`)
      dispatch({
        type: GET_MATERIAL_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_MATERIAL_FAILURE
      })
    }
  }
}

export const getMaterialByCategoryId = (categoryId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_MATERIAL_BY_CATEGORY_ID_REQUEST
      })

      const response = await API.get(
        EndPoints.PRODUCT + `/listByCategory/${categoryId}`
      )
      dispatch({
        type: GET_MATERIAL_BY_CATEGORY_ID_SUCCESS,
        payload: response.data.data
      })
    } catch (err) {
      dispatch({
        type: GET_MATERIAL_BY_CATEGORY_ID_FAILURE
      })
    }
  }
}

export const saveSelectedList = (data) => {
  return async (dispatch) => {
    dispatch({
      type: SAVE_SELECTED_LIST,
      payload: data
    })
  }
}

export const saveMaterialList = (data) => {
  return async (dispatch) => {
    dispatch({
      type: SAVE_MATERIAL_LIST,
      payload: data
    })
  }
}

export const removeSelectedList = (data) => {
  return async (dispatch) => {
    dispatch({
      type: REMOVE_SELECTED_LIST,
      payload: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/stores/material.js